import React from 'react';
import { Navigate } from 'react-router-dom';
import { Alert, Box } from '@mui/material';
import { useUser } from '../hooks/useUser';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { userInfo, loading, isAdmin } = useUser();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        Loading user permissions...
      </Box>
    );
  }

  if (!userInfo || !isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access denied. You must be an administrator to view this page.
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AdminRoute; 